import * as ArrayUtils from "@/utils/ArrayUtils";
import * as NumberFormatUtils from "@/utils/NumberFormatUtils";

export default {
  machines(state) {
    return state.machines;
  },
  basicData(state) {
    return state.basicData;
  },
  orderList(state) {
    return state.orderList;
  },
  orderListOnProduction(state, getters) {
    return getters.orderList.filter(o => !o.isOnHold);
  },
  orderListOnHold(state, getters) {
    return getters.orderList.filter(o => o.isOnHold);
  },
  deliveryTypes(state) {
    return state.deliveryTypes;
  },
  allOrdersAmount(state, getters) {
    return ArrayUtils.countElementsByKey(getters.orderList, "amountOfCanisters");
  },
  onProductionAmount(state, getters) {
    return ArrayUtils.countElementsByKey(getters.orderListOnProduction, "amountOfCanisters");
  },
  onHoldAmount(state, getters) {
    return ArrayUtils.countElementsByKey(getters.orderListOnHold, "amountOfCanisters");
  },
  orderListAmount(state, getters) {
    return ArrayUtils.countElementsByKey(getters.orderList, "amountOfCanisters");
  },
  onProductionAmountByDeliveryTypeId(state, getters) {
    return deliveryTypeId =>
      getters.orderListOnProduction
        .filter(o => o.deliveryTypeId === deliveryTypeId)
        .reduce((prev, cur) => prev + cur.amountOfCanisters, 0);
  },
  formatPrice(state, getters) {
    return price =>
      NumberFormatUtils.formatCurrency(price, getters.basicData.currencyId, getters.basicData.currencyFormattingLocale);
  },
  onProductionElements(state, getters) {
    const elements = [];
    getters.deliveryTypes.forEach(p => {
      const list = getters.orderListOnProduction.filter(pl => pl.deliveryTypeId === p.id);
      const canisters = ArrayUtils.countElementsByKey(list, "amountOfCanisters");
      if (canisters > 0) {
        const price = getters.priceList.find(pl => pl.deliveryTypeId === p.id);
        const totalPrice = (canisters * parseFloat(price.netPrice)).toFixed(2);
        elements.push({
          ...p,
          totalPrice: getters.formatPrice(totalPrice),
          netPrice: price.netPrice,
          canisters
        });
      }
    });
    return elements;
  },
  onHold(state, getters) {
    const canisters = ArrayUtils.countElementsByKey(getters.orderListOnHold, "amountOfCanisters");
    const delivery = getters.deliveryTypes.find(dt => dt.canBeOnHold);
    const price = getters.priceList.find(pl => pl.deliveryTypeId === delivery.id);
    const totalPrice = canisters * parseFloat(price.netPrice).toFixed(2);
    const vatPrice = totalPrice * (getters.basicData.vatTaxRate / 100);
    return {
      ...delivery,
      price,
      canisters,
      totalPrice,
      vatPrice
    };
  },
  onHoldDeliveryDetails(state) {
    return state.onHoldDeliveryDetails;
  },
  priceList(state) {
    return state.priceList;
  },
  freeContingent(state) {
    return state.freeContingent;
  },
  machineId(state) {
    return state.machineId;
  },
  referenceNumber(state) {
    return state.referenceNumber;
  },
  selectedMachine(state) {
    return state.machines.find(machine => machine.id === state.machineNumber);
  }
};
